<template>
  <b-dropdown right no-caret class="h-dropdown">
    <template v-slot:button-content>
      <v-avatar
          class="me-5"
          color="light-blue"
          size="32">
              <span v-if="!avatar"
                    class="white--text text-body-2">{{ keyAvatar }}</span>
        <img v-else
             alt="Avatar"
             :src="avatar">
      </v-avatar>
    </template>
    <b-dropdown-item
        v-if="isAllowUserInfo"
        class="h-dropdown-item"
        @click="goToDetailUser">
      <div class="d-flex">

        <img width="20" height="20" src="@/assets/images/ic-user.svg"/>
        <span size="20" class="ms-2">
        {{ $t("header.accountInfo") }}
        </span>
      </div>
    </b-dropdown-item>

    <b-dropdown-item
        class="h-dropdown-item"
        @click="onLogout">
      <div class="d-flex">
        <img width="20" height="20" src="@/assets/images/ic-logout.svg"/>
        <div size="20" class="ms-2">
          {{ $t("header.logout") }}
        </div>

      </div>

    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import {mapActions, mapState} from "vuex";
import storage from "../helper/storage";
import routes from "../routes";
import mixin from "../mixin";
import path from "../routes/path";
import {FUNCTION_ID, getAccountPermission} from "../helper/functions";

export default {
  name: "DefaultHeaderDropdownAccnt",
  mixins: [mixin],
  components: {},
  data: () => {
    return {
      avatar: null,
      itemsCount: 42,
    };
  },
  computed: {
    ...mapState(['accountInfo']),
    keyAvatar() {
      return this.getKeyAvatar(this.accountInfo ? this.accountInfo.name : null)
    },
    isAllowUserInfo() {
      let permission = getAccountPermission(this.accountInfo)
      return permission ? permission[FUNCTION_ID.USER_INFO] : false
    }
  },
  methods: {
    ...mapActions(["logout"]),
    onLogout() {
      this.logout();
      storage.clear();
      routes.push(path.login)
    },
    goToDetailUser() {
      routes.push(path.user)
    },
  },
};
</script>

<style>

.h-dropdown > .dropdown-menu {
  padding-left: 0;
}

.h-dropdown > .btn-secondary.dropdown-toggle {
  background: #fff;
  border-color: #fff;
}

.h-dropdown > .btn-secondary.dropdown-toggle:focus {
  box-shadow: none;
  background: #fff;
  border-color: #fff;
}


.h-dropdown > .btn-secondary.dropdown-toggle:hover {
  box-shadow: none;
  background: #fff;
  border-color: #fff;
}

.h-dropdown > .btn-secondary.dropdown-toggle:active {
  box-shadow: none;
  background: #fff;
  border-color: #fff;
}


.h-dropdown-item > .dropdown-item {
  color: #000000;
}

.h-dropdown-item > .dropdown-item:hover {
  color: #000000;
  font-weight: bold;
}

.h-dropdown-item > .dropdown-item:focus {
  color: #000000;
  font-weight: bold;
}

</style>
